// Módulo 1	
// Inversores 2	
// Stringbox 4	
// Itens para Estrutura 10	
// Acessórios 11	
// Perfil de Alumínio 19	
// Kit de Estrutura de Fixação 20	
// Emenda para Perfil de Alumínio 21	
// Grampo Intermediário 22	
// Cabo 23	
// Conector 24	
// Kit de Junção 25	
// Suporte 26	
// Chapa Metálica 27	
// Grampo Final 28	
// Suporte de Solo 29	
// Microinversor 30	
// Conector AC Fêmea p/ Microinversor 31	
// Terminal Final Fêmea p/ Microinversor 32	
// Roteador 33	
// Grampo de Fixação p/ Microinversor 34	
// Mão Francesa 35	
// Controladores de Carga 100	
// Baterias 110	
// Iluminação Solar 120	
// Onda Senoidal 130	
// Onda Modificada 140	
// Drive Solar 150	
// Carregador 160	

export const MODULO_ID = 1;
export const INVERSOR_ID = 2;
export const STRINGBOX_ID = 4;
export const ITENS_PARA_ESTRUTURA_ID = 10;
export const ACESSORIOS_ID = 11;
export const PERFIL_ALUMINIO = 19;
export const KIT_ESTRUTURA_FIXACAO = 20;
export const EMENDA_PARA_PERFIL_DE_ALUMINIO = 21
export const GRAMPO_INTERMEDIARIO_ID = 22
export const CABO_ID = 23
export const CONECTOR_ID = 24
export const KIT_DE_JUNCAO_ID = 25
export const SUPORTE_ID = 26
export const CHAPA_METALICA_ID = 27
export const GRAMPO_FINAL_ID = 28
export const SUPORTE_DE_SOLO_ID = 29
export const MICROINVERSOR_ID = 30
export const CONECTOR_AC_FEMEA_MICROINVERSOR_ID = 31
export const TERMINAL_FINAL_FEMEA_MICROINVERSOR_ID = 32
export const ROTEADOR_ID = 33
export const GRAMPO_DE_FIXACAO_MICROINVERSOR_ID = 34
export const MAO_FRANCESA_ID = 35
export const CONTROLADORES_DE_CARGA_ID = 100
export const BATERIAS_ID = 110
export const ILUMINACAO_SOLAR_ID = 120
export const ONDA_SENOIDAL_ID = 130
export const ONDA_MODIFICADA_ID = 140
export const DRIVE_SOLAR_ID = 150
export const CARREGADOR_ID = 160	

export const INVERSORES = [INVERSOR_ID, MICROINVERSOR_ID, ONDA_SENOIDAL_ID, ONDA_MODIFICADA_ID, DRIVE_SOLAR_ID, CARREGADOR_ID];
export const INVERSORES_OFFGRID = [ONDA_SENOIDAL_ID, ONDA_MODIFICADA_ID, DRIVE_SOLAR_ID, CARREGADOR_ID];
export const INVERSORES_ONDA = [ONDA_SENOIDAL_ID, ONDA_MODIFICADA_ID];

export const EXIBIR_ATRIBUTOS = [MODULO_ID, STRINGBOX_ID, CABO_ID, ...INVERSORES];

export const VALOR_MULTIPLO_CABO = 25

export const TENSAO_SAIDA: Record<number, string> = {
    1: "127/220",
    2: "220/380",
    3: "127",
    4: "220",
    5: "380",
    6: "24",
    7: "48",
};

export const TIPO_CONEXAO: Record<number, string> = {
    1: "Monofásico",
    2: "Bifásico",
    3: "Trifásico",
};

export const TIPO_CABO: Record<number, string> = {
    1: "Cabo Solar Vermelho",
    2: "Cabo Solar Preto",
    3: "Cabo Solar Verde",
};

const mapValoresMultiplos = (valor: any, lista: Record<number, string>) => {
    if (!valor) return "";
    return String(valor).split(",").map(v => lista[Number(v.trim())]).filter(Boolean).join(", ");
};

export const ATRIBUTOS_MAP: Record<string | number, Record<string, {
    label: string;
    format?: (v: any) => any;
}>> = {
    [MODULO_ID]: {
        MODULO_POTENCIA: { label: "Potência (Wp)" },
        MODULO_LARGURA_CALCULO: { label: "Largura para Cálculo (mm)", format: v => Number(v) },
        MODULO_ALTURA_CALCULO: { label: "Altura para Cálculo (mm)", format: v => Number(v) },
        LARGURA_MODULO: { label: "Frame do Módulo (mm)" },
        MODULO_TENSAO_VOC: { label: "Tensão Voc Corrigida com Temperatura (V)" },
        MODULO_CORRENTE_MAXIMA_STC: { label: "Corrente Máxima STC (A)" },
        MODULO_TENSAO_VMP: { label: "Tensão VMP (V)" }
    },

    [INVERSOR_ID]: {
        INVERSOR_POTENCIA_MAXIMA_ENTRADA: { label: "Potência Máxima de Entrada CC (Wp)" },
        INVERSOR_TENSAO_INICIALIZACAO: { label: "Tensão de Inicialização CC (V)" },
        INVERSOR_TENSAO: {
            label: "Tensão nominal de saída (V)",
            format: v => mapValoresMultiplos(v, TENSAO_SAIDA)
        },
        INVERSOR_TIPO_CONEXAO: {
            label: "Tipo Conexão",
            format: v => mapValoresMultiplos(v, TIPO_CONEXAO)
        }
    },

    "INVERSORES_ONDA": {
        INVERSOR_ONDA_POTENCIA_MAXIMA: { label: "Potência Máxima (W)" },
        INVERSOR_ONDA_POTENCIA_INSTANTANEA_PICO_SUPORTADA: {
            label: "Potência instantânea de pico suportada (Wp)"
        },
        INVERSOR_ONDA_CORRENTE_MAXIMA_ENTRADA: {
            label: "Corrente máxima de entrada (A)"
        },
        INVERSOR_ONDA_TENSAO_SAIDA: {
            label: "Tensão de saída (V)",
            format: v => mapValoresMultiplos(v, TENSAO_SAIDA)
        }
    },

    [MICROINVERSOR_ID]: {
        INVERSOR_MAXIMO_SERIE: { label: "Máximo em Série" },
        QUANTIDADE_MPPT: { label: "Quantidade MPPT" },
        INVERSOR_TENSAO: {
            label: "Tensão nominal de saída (V)",
            format: v => mapValoresMultiplos(v, TENSAO_SAIDA)
        },
        INVERSOR_TIPO_CONEXAO: {
            label: "Tipo Conexão",
            format: v => mapValoresMultiplos(v, TIPO_CONEXAO)
        }
    },

    [DRIVE_SOLAR_ID]: {
        DRIVE_SOLAR_POTENCIA_NOMINAL_SAIDA: { label: "Potência nominal de saída (CV)" },
        DRIVE_SOLAR_MAXIMA_CORRENTE_SAIDA: { label: "Máxima corrente de saída (A)" },
        DRIVE_SOLAR_MAXIMA_POTENCIA_FOTOVOLTAICA: { label: "Máxima potência fotovoltaica (W)" },
        DRIVE_SOLAR_TENSAO_ENTRADA: { label: "Tensão de entrada (V)" }
    },

    [CARREGADOR_ID]: {
        INVERSOR_CARREGADOR_POTENCIA_MAXIMA_FV: { label: "Potência Máxima FV (W)" },
        INVERSOR_CARREGADOR_POTENCIA_MAXIMA_SAIDA: { label: "Potência Máxima de Saída (W)" },
        INVERSOR_ONDA_TENSAO_NOMINAL_ENTRADA: { label: "Tensão nominal de entrada (V)" },
        INVERSOR_ONDA_TENSAO_SAIDA: {
            label: "Tensão de saída (V)",
            format: v => mapValoresMultiplos(v, TENSAO_SAIDA)
        }
    },

    [STRINGBOX_ID]: {
        STRINGBOX_ENTRADAS: { label: "Entradas" },
        STRINGBOX_SAIDAS: { label: "Saídas" }
    },

    [CABO_ID]: {
        TIPO_CABO: {
            label: "Tipo de Cabo",
            format: v => TIPO_CABO[Number(v) || 0] ?? ""
        }
    }
};

export const ORDENATION_OPTIONS = [
    {
        label: 'Destaques',
        value: 'DESTAQUE',
    },
    {
        label: 'Lançamentos',
        value: 'LANCAMENTO',
    },
    {
        label: 'Promocional',
        value: 'PROMOCIONAL',
    },
    {
        label: 'Treinamento',
        value: 'TREINAMENTO',
    },
    {
        label: 'Showroom',
        value: 'SHOWROOM',
    },
    {
        label: 'Maior potência',
        value: 'potencia_desc',
    },
    {
        label: 'Menor potência',
        value: 'potencia',
    },
    {
        label: 'Maior preço',
        value: 'preco_desc',
    },
    {
        label: 'Menor preço',
        value: 'preco',
    }
]

export const ORDENATION_AVULSO_OPTIONS = [
    {
        label: 'Maior preço',
        value: 'valor_desc',
    },
    {
        label: 'Menor preço',
        value: 'valor',
    }
]

export const ESTADOS = [
    {
        label: 'Acre',
        value: 'AC',
    },
    {
        label: 'Alagoas',
        value: 'AL',
    },
    {
        label: 'Amapá',
        value: 'AP',

    },
    {
        label: 'Amazonas',  
        value: 'AM',
    },
    {   
        label: 'Bahia',
        value: 'BA',
    },
    {
        label: 'Ceará',
        value: 'CE',
    },
    {
        label: 'Distrito Federal',
        value: 'DF',
    },
    {
        label: 'Espírito Santo',
        value: 'ES',
    },
    {
        label: 'Goiás',
        value: 'GO',
    },
    {
        label: 'Maranhão',
        value: 'MA',
    },
    {
        label: 'Mato Grosso',
        value: 'MT',
    },
    {
        label: 'Mato Grosso do Sul',
        value: 'MS',
    },
    {
        label: 'Minas Gerais',
        value: 'MG',
    },
    {
        label: 'Pará',
        value: 'PA',
    },
    {
        label: 'Paraíba',
        value: 'PB',
    },
    {
        label: 'Paraná',
        value: 'PR',
    },
    {
        label: 'Pernambuco',
        value: 'PE',
    },
    {
        label: 'Piauí',
        value: 'PI',
    },
    {
        label: 'Rio de Janeiro',
        value: 'RJ',
    },
    {
        label: 'Rio Grande do Norte',
        value: 'RN',
    },
    {
        label: 'Rio Grande do Sul',
        value: 'RS',
    },
    {
        label: 'Rondônia',
        value: 'RO',
    },
    {
        label: 'Roraima',
        value: 'RR',
    },
    {
        label: 'Santa Catarina',
        value: 'SC',
    },
    {
        label: 'São Paulo',
        value: 'SP',
    },
    {
        label: 'Sergipe',
        value: 'SE',
    },
    {
        label: 'Tocantins',
        value: 'TO',
    },
]

export const TIPO_INVERSOR = [
    {
        label: 'Ambos',
        value: 'ambos',
    },
    {
        label: 'String',
        value: 'string',
    },
    {
        label: 'Microinversor',
        value: 'microinversor',
    },
          
]

export const TIPO_INVERSOR_OFFGRID = [
    {
        label: 'Onda modificada',
        value: 'onda_modificada',
    },
    {
        label: 'Onda senoidal',
        value: 'onda_senoidal',
    },
    {
        label: 'Drive solar',
        value: 'drive_solar',
    },
    {
        label: 'Carregador',
        value: 'carregador',
    }
]


export const NUMERO_FASES_INVERSOR = [
    {
        label: 'Monofásico',
        value: '1',
    },
    {
        label: 'Bifásico',
        value: '2',
    },
    {
        label: 'Trifásico',
        value: '3',
    },
]

// {"enum": [{"text": "127/220", "value": 1}, {"text": "220/380", "value": 2}, {"text": "127", "value": 3}, {"text": "220", "value": 4}, {"text": "380", "value": 5}]}
export const TENSAO_INVERSOR = [
    {
        label: '127/220',
        value: '1',
    },
    {
        label: '220/380',
        value: '2',
    }
]

// Todos
// Kits
// Módulos
// Inversores
// Microinversores
// Estruturas
// Acessorios
// Baterias
// Controladores de Carga
// Iluminação Solar
// Onda Senoidal
// Drive Solar
// Carregador
// Onda Modificada
export const CATEGORIAS = [
    {
        label: 'Todos',
        value: '',
        segmento: 'todos',
    },
    {
        label: 'Kits',
        value: 'gerador',
        segmento: 'todos',
    },
    {
        label: 'Módulo',
        value: 'modulo',
        segmento: 'todos',
    },
    {
        label: 'Inversor string',
        value: 'inversor',
        segmento: 'on',
    },
    {
        label: 'Microinversores',
        value: 'microinversores',
        segmento: 'on',
    },
    {
        label: 'Onda Senoidal',
        value: 'onda_senoidal',
        segmento: 'off',
    },
    {
        label: 'Drive Solar',
        value: 'drive_solar',
        segmento: 'off',
    },
    {
        label: 'Carregador',
        value: 'carregador',
        segmento: 'off',
    },
    {
        label: 'Onda Modificada',
        value: 'onda_modificada',
        segmento: 'off',
    },
    {
        label: 'Estruturas',
        value: 'estruturas',
        segmento: 'todos',
    },
    {
        label: 'Acessórios',
        value: 'acessorios',
        segmento: 'todos',
    },
    {
        label: 'Baterias',
        value: 'baterias',
        segmento: 'off',
    },
    {
        label: 'Controladores de carga',
        value: 'controladores',
        segmento: 'off',
    },
    {
        label: 'Iluminação Solar',
        value: 'iluminacao',
        segmento: 'off',
    },
];

// {"enum": [{"text": "MPPT", "value": 1}, {"text": "PWM", "value": 2}]}
export const TECNOLOGIA_CONTROLADOR_CARGA = [
    {
        label: 'PWM',
        value: '2',
    
    },
    {
        label: 'MPPT',
        value: '1',
    },
];

// {"enum": [{"text": "12", "value": 12}, {"text": "24", "value": 24}, {"text": "36", "value": 36}, {"text": "48", "value": 48}]}
export const TENSAO_BATERIA = [
    {
        label: '12 V',
        value: '12',
    },
    {
        label: '24 V',
        value: '24',
    },
    {
        label: '36 V',
        value: '36',
    },
    {
        label: '48 V',
        value: '48',
    },
]

// {"enum": [{"text": "Chumbo", "value": 1}, {"text": "Lítio", "value": 2}]}
export const TIPO_BATERIA = [
    {
        label: "Chumbo",
        value: "1"
    },
    {
        label: "Lítio",
        value: "2"
    },
]
